/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';

import ErrorBanner from '../components/Banner/ErrorBanner';
import Footer from '../components/Footer/Footer';
import ForgotUsernamePasswordTile from '../components/ForgotUsernamePasswordTile/ForgotUsernamePasswordTile';
import GreetingPanel from '../components/GreetingPanel/GreetingPanel';
import LinkImageText from '../components/LinkImageText/LinkImageText';
import LoginTile from '../components/LoginTile/LoginTile';
import PhNavigation from '../components/PhNavigation/PhNavigation';
import PreLoginTile from '../components/PreLoginTile/PreLoginTile';
import SSOModal from '../components/PreRegistration/SSOModal';
import ProfileConfirmation from '../components/ProfileConfirmation/ProfileConfirmation';
import Registration from '../components/Registration/Registration';
import StudyCard from '../components/StudyCard/StudyCard';
import Loader from '../components/shared/Loader/Loader';

const components = new Map();

components.set('ErrorBanner', ErrorBanner);
components.set('Footer', Footer);
components.set('ForgotUsernamePasswordTile', ForgotUsernamePasswordTile);
components.set('GreetingPanel', GreetingPanel);
components.set('LinkImageText', LinkImageText);
components.set('LoginTile', LoginTile);
components.set('PhNavigation', PhNavigation);
components.set('PreLoginTile', PreLoginTile);
components.set('SSOModal', SSOModal);
components.set('ProfileConfirmation', ProfileConfirmation);
components.set('Registration', Registration);
components.set('StudyCard', StudyCard);
components.set('Loader', Loader);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
